import React from "react"
import PropTypes from "prop-types"

import DashMoreToDoSection from './DashMoreToDo';
import EarlyMemberAlert from './EarlyMemberAlert';
import UserGamificationDashboard from './UserGamificationDashboard';

class UnapprovedUserDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: [],
      notifications: [],
      pointsEarned: [],
      pointsUsed: [],
      dataLoaded: false,
      width: 0
    }
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    })
  }

  componentWillMount() {
    $.ajax({
      url: `../getUserData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          currentUser: JSON.parse(data.data.current_user),
          notifications: JSON.parse(data.data.notifications),
          pointsEarned: JSON.parse(data.data.pointsEarned),
          pointsUsed: JSON.parse(data.data.pointsUsed),
          dataLoaded: true,
          languages: JSON.parse(data.data.learning_languages)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    if(this.state.dataLoaded) {
      return(
        <div style={{margin: 'auto', maxWidth: 600, marginBottom: 100}}>
              <div className="userGamificationDashboard" style={{marginBottom: 40}}>
                <UserGamificationDashboard
                  currentUser={this.state.currentUser}
                  lexicoin={this.props.lexicoin}
                  connectCoin={this.props.connectCoin}
                  lexes={this.state.lexes}
                  pointsEarned={this.state.pointsEarned}
                  pointsUsed={this.state.pointsUsed}
                  missingImg={this.props.missingImg}
                />
              </div>
              <EarlyMemberAlert user={this.state.currentUser} twitter_icon={this.props.twitter_icon} facebook_icon={this.props.facebook_icon}/>
              <DashMoreToDoSection
                width={this.state.width}
                languages={this.state.languages}
                readingIcon={this.props.readingIcon}
                writingIcon={this.props.writingIcon}
              />
        </div>
      )
    }
    return null
  }

}

export default UnapprovedUserDashboard;
